var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mts-dialog',{attrs:{"visible":_vm.visible,"title":"Описание"},on:{"close":function($event){return _vm.$emit('on-close-desc')}}},[_c('span',[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }